export default __webpack_public_path__ + "static/media/ezgif.com-gif-maker.fdaea68f.gif";